// Our Awards Component

import React, { useEffect, useRef, useState } from "react"
import { ConnectWithUsBtns } from "../home/home"
// import { useAppContext } from "../../context/appContext"
// import gtag from "ga-gtag"

import "./Awards.scss"
import { Link } from "gatsby"
import { motion } from "motion/react"

const Awards = ({
  data,
  title = "Awards & Recognition",
  subTitle,
  showConnectBtns = false,
  isHomePage = false,
}) => {
  // const { setShowChatWindow, setShowContactFormWindow } = useAppContext()

  const [showBothButtons, setShowBothButtons] = useState(false)
  const [activeCardIndex, setActiveCardIndex] = useState(null)

  const awardsContainerRef = useRef<HTMLDivElement | null>(null)

  const handleMouseEnter = index => {
    setActiveCardIndex(index)
  }

  const handleMouseLeave = () => {
    setActiveCardIndex(null)
  }

  const handleCardClick = index => {
    setActiveCardIndex(activeCardIndex === index ? null : index)
  }

  // const onContactUsBtnClick = ctaTitle => {
  //   setShowContactFormWindow(true)

  //   gtag("event", ctaTitle, {
  //     event_category: "contact-us",
  //     event_label: "Contact Form",
  //   })
  // }

  const handleClickOutside = event => {
    if (
      awardsContainerRef.current &&
      !awardsContainerRef.current.contains(event.target)
    ) {
      setActiveCardIndex(null)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div
      className={`section homepage homepage-awards-recognition-section ${
        isHomePage ? "new-homepage-awards" : ""
      }`}
      id="awards-recognition-section"
    >
      <motion.div
        whileInView={{ opacity: 1, y: 0 }}
        // viewport={{ once: true }}
        initial={false}
        animate={{ opacity: 0, y: 20 }}
        transition={{ type: "linear", delay: 0.15 }}
        className="awards-section-header"
      >
        <h2 className="homepage-section-title">{title}</h2>
        {subTitle && <h3 className="homepage-section-sub-title">{subTitle}</h3>}
      </motion.div>
      <div className="awards-cards-container" ref={awardsContainerRef}>
        {data?.map((award, index) => (
          <motion.div
            // className="award-card"
            whileInView={{ opacity: 1, y: 0 }}
            initial={false}
            animate={{ opacity: 0, y: "10%" }}
            transition={{
              type: "spring",
              delay: 0.1 * index + 0.05,
            }}
            className={`${
              data.length % 2 !== 0 ? (index === 0 ? "exp" : "not-exp") : ""
            } award-card`}
            key={index}
            onClick={() => handleCardClick(index)}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={() => handleMouseLeave()}
          >
            <img
              src={award.AwardImage?.asset?.url}
              alt={`award-${index + 1}`}
              className={`award-image ${
                activeCardIndex === index ? "add-blur" : ""
              }`}
              loading="lazy"
            />
            <div
              className={`${
                activeCardIndex === index ? "fade-in" : "fade-out"
              } card-content`}
              style={{
                display: activeCardIndex === index ? "flex" : "none",
              }}
            >
              <p className="award-year">{award?.AwardYear}</p>
              <a
                className="award-details"
                href={award?.LearnMore ? award?.LearnMore : ""}
                target="_blank"
                rel="noreferrer"
                title={`Click to learn more about ${award?.AwardDescription}`}
              >
                <p
                  className="award-description"
                  style={{ fontWeight: "normal" }}
                >
                  {award?.AwardDescription}
                </p>
                <span className="learn-more-cta">Learn more</span>
              </a>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Connect buttons */}
      {showConnectBtns ||
        (isHomePage && (
          <motion.div
            whileInView={{ opacity: 1, y: 0 }}
            // viewport={{ once: true }}
            initial={false}
            animate={{ opacity: 0, y: 20 }}
            transition={{ type: "linear", delay: 0.15 }}
            className="cta-container"
          >
            <h3 className="cta-title">
              Our award-winning team is here to elevate your AI game
            </h3>
            {isHomePage ? (
              <div className="new-buttons-wrapper">
                <div className="new-button-container">
                  <Link to="/book-demo">
                    <button className={`old-design blue standout`}>
                      Find Out How
                    </button>
                  </Link>
                </div>
              </div>
            ) : (
              <ConnectWithUsBtns
                showBothButtons={showBothButtons}
                setShowBothButtons={setShowBothButtons}
              />
            )}
          </motion.div>
        ))}
    </div>
  )
}

export default Awards
